/**
 * Project Name: Kickoff
 * @description The Kickoff boilerplate js file
 * @author The Kickoff team
 *
 * Need help using JSDoc? Find out more at http://usejsdoc.org/
 */

// their code e.g. npm modules

// Global libs that don't return a value
import 'console';
import $ from 'jquery';
import slick from 'slick-carousel'; 


$(window).on('resize', function() {
  $('.property-slider__thumbnails').slick('resize');
});


$(".property-slider__images").slick({
   slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.property-slider__thumbnails'
});


$(".property-slider__thumbnails").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.property-slider__images',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    vertical:true
});


$(".testimonial__slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true,
});



  $(".hero__slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows:true,
  });


$(".recent-properties__slider").slick({
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./assets/src/js/script.js